<div class="empty-state-container">
    <div class="empty-state-box" [ngStyle]="{'width': mobile ? sizeContainerMobile : sizeContainer, 'height': 'fit-content'}">
        <div [ngStyle]="{
            'width':sizeIcon && !mobile ? sizeIcon : mobile ? sizeIconMobile : condensed ? '1.875rem' : '3.125rem' , 
            'height':sizeIcon && !mobile ? sizeIcon : mobile ? sizeIconMobile : 'fit-content'}">
            <mat-icon class="icon-state" [ngClass]="{'_condensed': condensed}" *ngIf="icon" [svgIcon]="icon"></mat-icon>
        </div>
        <div class="description-container" [ngClass]="{'_condensed': condensed}">
            <span class="title">
                {{ title }}
            </span>
            <span class="description">
                {{ description }}
            </span>
        </div>
    </div>
</div>